<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <div class="p-3">
                    <v-card class="mb-3" style="background-color: #f3f6f9;" elevation="0">
                        <v-container>
                            <div class="text-caption pb-1 indigo--text text--darken-4 font-weight-bold">
                                Filter
                            </div>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <label class="text-caption indigo--text text--darken-4">Berdasarkan jenis surat</label>
                                    <v-select small-chips dense class="pb-0" :items="selectOptions.jenis_surat"
                                        item-text="nama_jenis_surat" item-value="kode_jenis_surat"
                                        v-model="kode_jenis_surat" label="Jenis surat" @change="onChangeJenisSurat($event)"
                                        solo></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-card>
                        <v-card-title>
                            <v-row>
                                <v-col md="4" sm="12">
                                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Cari" single-line
                                        @keyup="onKeyup($event)" hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-data-table :headers="columns" :items="rows" item-key="name" sort-by="calories" :search="search"
                            :loading="isLoading" loading-text="Mengambil data... Mohon tunggu" :server-items-length="count"
                            @pagination="onChangePagination($event)" class="elevation-1">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Kelola Surat</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-menu offset-y close-on-content-click>
                                        <template v-slot:activator="{ on }">
                                            <v-btn outlined color="indigo darken-4 white--text" class="mb-2 ml-2" v-on="on">
                                                <v-icon left>mdi-eye-circle</v-icon>Lihat template surat<v-divider
                                                    class="px-2" vertical></v-divider>
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <a :href="onClickPrintTemplate('SPP')">
                                                    <v-list-item-title>Surat pengantar perusahaan</v-list-item-title>
                                                </a>
                                            </v-list-item>
                                            <v-list-item>
                                                <a :href="onClickPrintTemplate('STM')">
                                                    <v-list-item-title>Surat tugas mahasiswa</v-list-item-title>
                                                </a>
                                            </v-list-item>
                                            <v-list-item>
                                                <a :href="onClickPrintTemplate('SDP')">
                                                    <v-list-item-title>Surat pembimbing</v-list-item-title>
                                                </a>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <v-menu offset-y close-on-content-click>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="indigo darken-4 white--text" class="mb-2 ml-2" v-on="on">
                                                <v-icon left>mdi-email-plus</v-icon>Buat surat<v-divider class="px-2"
                                                    vertical></v-divider>
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item v-for="(item, index) in dropdownSurat" :key="index"
                                                :to="{ name: 'manage-letter.create', query: { kode_surat: item.kode_surat } }">
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <!-- <v-icon color="dark" class="mr-2" @click="onEditLetter(item)">
                                    mdi-file-edit
                                </v-icon> -->
                                <a :href="onPrintClick(item.id)" target="_blank">
                                    <v-icon color="dark" class="mr-2">
                                        mdi-printer
                                    </v-icon>
                                </a>
                            </template>
                            <template v-slot:no-data>
                                <br>
                                Belum ada data<br>
                                <v-btn class="m-4" color="gray" @click="resetFilter">
                                    Mulai ulang
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </template>
        </v-container>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            selectOptions: {
                jenis_surat: [
                    {
                        nama_jenis_surat: 'Semua',
                        kode_jenis_surat: ''
                    },
                    {
                        nama_jenis_surat: 'Surat permohonan perusahaan',
                        kode_jenis_surat: 'SPP'
                    },
                    {
                        nama_jenis_surat: 'Surat tugas mahasiswa',
                        kode_jenis_surat: 'STM'
                    }
                ],
            },
            filterSelected: {
                kode_jenis_surat: ''
            },
            dropdownSurat: [
                {
                    title: 'Surat permohonan perusahaan',
                    kode_surat: 'SPP',
                },
                {
                    title: 'Surat tugas mahasiswa',
                    kode_surat: 'STM',
                },
            ],
            dropdownTemplateSurat: [
                {
                    title: 'Surat permohonan perusahaan',
                    kode_surat: 'SPP',
                },
                {
                    title: 'Surat tugas mahasiswa',
                    kode_surat: 'STM',
                },
                {
                    title: 'Surat pembimbing',
                    kode_surat: 'SDP',
                },
            ],
            columns: [
                { text: 'No. Surat', align: 'start', value: 'no_surat', },
                { text: 'User', align: 'start', value: 'mahasiswa', },
                { text: 'Jenis Surat', value: 'jenis_surat' },
                { text: 'Tanggal surat', value: 'tanggal_surat' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            isLoading: false,
            kode_jenis_surat: '',
            search: '',
            list_letters: [],
            rows: [],
            count: 10,
            dialogSPP: false,
            valid: true,
            datePicker1: false,
            tanggal_realisasi_mulai_kp: null
        }
    }, created() {
    },
    computed: {
        format_tanggal_realisasi_mulai_kp() {
            return this.formatDate(this.tanggal_realisasi_mulai_kp);
        }
    },
    watch: {
        'search'(newValue) {
            // if (newValue) this.getData();
        }
    },
    methods: {
        getData() {
            this.isLoading = true;
            const params = {
                kode_jenis_surat: this.kode_jenis_surat,
                cari: this.search,
                limit: this.limit == -1 ? 5000 : this.limit,
                offset: this.offset,
            };
            this.axios.get("/api/surat", { params: params }).then((res) => {
                this.count = res.data.count;
                this.rows = res.data.data.map(val => {
                    val.mahasiswa = val.mahasiswa.map(x => {
                        return x.nama;
                    })
                    val.mahasiswa = val.mahasiswa.join(', ');
                    val.tanggal_surat = this.$dates.dateNoDayNoTime(val.tanggal_surat);;
                    return val;
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        onChangePagination(event) {
            this.limit = event.itemsPerPage;
            this.offset = event.itemsPerPage * (event.page - 1);
            this.getData();
        },
        onKeyup(event) {
            if (event.keyCode == 13) {
                this.getData();
            }
        },
        resetFilter() {
            this.filterSelected.kode_jenis_surat = '';
            this.search = '';
            this.getData();
        },
        onClickBuatSurat(kd) {
            switch (kd) {
                case 'SPP':
                    this.dialogSPP = true;
                    break;

                default:
                    break;
            }
        },
        onChangeJenisSurat(val) {

        },
        onEditLetter(row) {

        },
        resetDialog() {
            this.dialogSPP = false;
        },
        onPrintClick(id) {
            return this.$baseurl + '/api/surat/' + id;
        },
        onClickPrintTemplate(kode) {
            switch (kode) {
                case 'SPP':
                    return this.$baseurl + '/api/cetak/surat-pengantar';
                    break;
                case 'STM':
                    return this.$baseurl + '/api/cetak/surat-tugas';
                    break;
                case 'SDP':
                    return this.$baseurl + '/api/cetak/surat-bimbingan';
                    break;

                default:
                    break;
            }
        }
    }
}
</script>